const THUMBOR_URL = `https://thumbnail-cloud.homeimprovementpages.com.au/`;

export function getThumborURL(imageUrl, sizeOfImage, type, filter) {
  if (process.env.NODE_ENV !== 'production') {
    return imageUrl;
  }
  sizeOfImage = typeof sizeOfImage !== 'undefined' ? sizeOfImage : '0x0';
  type = typeof type !== 'undefined' ? type : 'smart';
  filter = typeof filter !== 'undefined' ? filter : '';

  if (typeof imageUrl === 'string') {
    imageUrl = imageUrl.trim();
  }

  if (imageUrl === '') {
    return imageUrl;
  }

  let filters = '';
  if (filter !== '') {
    filters = `/filters:${filter}`;
  }

  const resource = `${sizeOfImage}/${type}${filters}/${imageUrl}`;
  imageUrl = `${THUMBOR_URL}unsafe/${resource}`;

  return imageUrl;
}
